module.exports = __webpack_public_path__ + "static/media/phone-pick-job.fed1989e.svg";